import * as React from 'react';

import {CueCardStack} from '../../../../glossary/layout/cue-card-stack';

export function Zapier() {
    React.useEffect(() => {
        SetupZapier.loadZapierOnView();
    }, []);

    return (
        <div className='pad-16'>
            <CueCardStack cards={[cueCard]} noBookmark={true} />
            <link
                rel='stylesheet'
                href='https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css'
            />
            {/* Placeholder for Zapier Full Experience */}
            {/* @ts-expect-error */}
            <zapier-full-experience
                client-id='GLX4s5B2AvJcDS3qSGyhB2Xao7zKpOYBLkgaqhmq'
                theme='light'
                intro-copy-display='hide'
                app-search-bar-display='show'
                app-limit='6'
                app-exclusions='mailchimp,activecampaign,wufoo'
                zap-limit='3'
                zap-style='row'
                zap-create-from-scratch-display='show'
            />
        </div>
    );
}

// One-off for this page only, renders in the page content so it isn't covered by the integrations sidebar
const cueCard = {
    settingsKey: 'zapier',
    title: 'What is Zapier?',
    description:
        'Zapier is a third-party service that can connect Nutshell to hundreds of other systems. You can use the portal below to set up integrations using your own Zapier account.',
    location: 'banner',
    thumbnailPath: '/include/images/integration/zapier-transparent.png',
    backgroundColor: 'plumXlt',
    cta: {
        text: 'Learn more',
        actionType: 'external-link',
        url: 'https://www.nutshell.com/integrations/zapier',
    },
} as const;
